import Flex from "@/components-library/layout/flex";
import Grid from "@/components-library/layout/grid";
import classes from "./footer.module.scss";
import Label from "@/components-library/widgets/label";
import { Link } from "react-router-dom";
import Iubenda from "react-iubenda-policy";
import { SERVICES } from "@/static-texts/services";
import { FACILITATIONS } from "@/static-texts/facilitations";
import { LINKS } from "@/static-texts/links";
import { FINANCE } from "@/static-texts/finance";
function Footer() {
  return (
    <Flex justify="center" align="center" direction="column">
      <Grid columns="1fr 1fr 1fr" className={classes.contacts}>
        <Flex
          justify="center"
          align="center"
          direction="row"
          className={classes.container}
        >
          <img src={"/images/footer/PROSSIMITI-icon-phone.svg"} alt="Logo" />
          <Flex
            justify="center"
            align="flex-start"
            direction="column"
            className={classes.content}
          >
            <Label size="md" color="secondary">
              CHIAMACI
            </Label>
            <Label tag="h5" color="secondary" weight="bold">
              +39 353 44 33 037
            </Label>
          </Flex>
        </Flex>
        <Flex
          justify="center"
          align="center"
          direction="row"
          className={classes.container}
        >
          <img src={"/images/footer/PROSSIMITI-icon-whatsapp.svg"} alt="Logo" />
          <Flex
            justify="center"
            align="flex-start"
            direction="column"
            className={classes.content}
          >
            <Label size="md" color="secondary">
              SCRIVICI SU WHATSAPP
            </Label>
            <Label tag="h5" color="secondary" weight="bold">
              +39 335 75 41 573
            </Label>
          </Flex>
        </Flex>
        <Flex
          justify="center"
          align="center"
          direction="row"
          className={classes.container}
        >
          <img src={"/images/footer/PROSSIMITI-icon-email.svg"} alt="Logo" />
          <Flex
            justify="center"
            align="flex-start"
            direction="column"
            className={classes.content}
          >
            <Label size="md" color="secondary">
              SCRIVICI VIA EMAIL
            </Label>
            <Label tag="h5" color="secondary" weight="bold">
              info@prossimiti.it
            </Label>
          </Flex>
        </Flex>
      </Grid>
      <Grid columns="1fr 1fr 1fr 1fr 1fr 1fr 1fr" className={classes.links}>
        <Flex
          justify="flex-start"
          align="flex-start"
          direction="column"
          style={{ height: "fit-content" }}
        >
          <img src={"/images/footer/PROSSIMITI-logo-w.svg"} alt="Logo" />
        </Flex>
        <Flex
          justify="flex-start"
          align="flex-start"
          direction="column"
          className={classes.content}
        >
          <Label
            size="md"
            weight="bold"
            align="start"
            className={classes.title}
          >
            Riferimenti
          </Label>
          <Label size="sm" align="start">
            Sede: Via Tien An Men 21, Sassuolo (MO)
          </Label>
          <Label size="sm" align="start">
            Tel +39 353 44 33 037 / 335 75 41 573
          </Label>
          <Label size="sm">E-mail: info@prossimiti.it</Label>
          <Label size="sm">P.iva: 04026360364</Label>
          <Label size="sm">N° Polizza: PI-8413282442</Label>
        </Flex>
        <Flex
          justify="flex-start"
          align="flex-start"
          direction="column"
          className={classes.content}
        >
          <Label
            size="md"
            weight="bold"
            align="start"
            className={classes.title}
          >
            Prossimiti S.r.l.
          </Label>
          <Label size="sm">
            <Link to={LINKS.ABOUT} className={classes.link}>
              Chi siamo
            </Link>
          </Label>
          <Label size="sm">
            <Link to={LINKS.CONTACTS} className={classes.link}>
              Contatti
            </Link>
          </Label>
          <Label size="sm">
            <Link to={LINKS.PARTNERS} className={classes.link}>
              Partners
            </Link>
          </Label>
        </Flex>

        <Flex
          justify="flex-start"
          align="flex-start"
          direction="column"
          className={classes.content}
        >
          <Label size="md" weight="bold" className={classes.title}>
            Finanza Agevolata
          </Label>
          {Object.keys(FINANCE).map((key) => (
            <Label size="sm" key={key}>
              <Link to={FINANCE[key].button.link} className={classes.link}>
                {FINANCE[key].title}
              </Link>
            </Label>
          ))}
        </Flex>
        <Flex
          justify="flex-start"
          align="flex-start"
          direction="column"
          className={classes.content}
        >
          <Label size="md" weight="bold" className={classes.title}>
            Servizi
          </Label>
          {Object.keys(SERVICES).map((key) => (
            <Label size="sm" key={key}>
              <Link to={SERVICES[key].button.link} className={classes.link}>
                {SERVICES[key].title}
              </Link>
            </Label>
          ))}
        </Flex>
        <Flex
          justify="flex-start"
          align="flex-start"
          direction="column"
          className={classes.content}
        >
          <Label size="md" weight="bold" className={classes.title}>
            {"Agevolazioni in evidenza"}
          </Label>
          {Object.keys(FACILITATIONS).map((key) => (
            <Label size="sm" key={key}>
              <Link
                to={FACILITATIONS[key].button.link}
                className={classes.link}
              >
                {FACILITATIONS[key].title}
              </Link>
            </Label>
          ))}
        </Flex>
        <Flex
          justify="flex-start"
          align="center"
          direction="column"
          className={classes.content}
        >
          <Label
            size="md"
            weight="bold"
            align="start"
            className={classes.title}
          >
            Vieni a visitare i nostri social
          </Label>

          {/*<Label size="sm">Privacy e Cooky Policy</Label>*/}
          <Flex justify="center" align="center" direction="row">
            <img
              src={"/images/footer/PROSSIMITI-icon-instagram.svg"}
              alt="Logo"
              className={classes.icon}
              onClick={() => window.open(LINKS.INSTAGRAM, "_blank")}
            />
            <img
              src={"/images/footer/PROSSIMITI-icon-facebook.svg"}
              alt="Logo"
              className={classes.icon}
              onClick={() => window.open(LINKS.FACEBOOK, "_blank")}
            />
            <img
              src={"/images/footer/PROSSIMITI-icon-linkedin.svg"}
              alt="Logo"
              className={classes.icon}
              onClick={() => window.open(LINKS.LINKEDIN, "_blank")}
            />
          </Flex>
        </Flex>
      </Grid>
      <Flex
        justify="center"
        align="center"
        direction="row"
        className={classes.rights}
      >
        <Label size="sm" className={classes.label}>
          2025 All rights reserved PROSSIMITI S.r.l.
        </Label>
        <Iubenda id={60147723} type="cookie" styling="white">
          Cookie Policy
        </Iubenda>
        <Iubenda id={60147723} type="privacy" styling="white">
          Privacy Policy
        </Iubenda>
      </Flex>
    </Flex>
  );
}

export default Footer;
